// stores/configStore.js
import { defineStore } from 'pinia'
import http from '../api/httpRequest'

export default defineStore('adminconfig', {
  state: () => ({
    configList: [],       // 存储配置集合
    isLoaded: false,      // 配置是否已加载
    loading: false,       // 加载状态
    error: null           // 错误信息
  }),
  
  getters: {
    // 通过configKey获取单个配置值
    getConfigValueByKey: (state) => (key) => {
      const config = state.configList.find(item => item.configKey === key)
      return config ? config.configValue : null
    },
    
    // 通过configKey获取完整配置对象
    getConfigByKey: (state) => (key) => {
      return state.configList.find(item => item.configKey === key)
    },
    
    // 筛选多个configKey的配置
    getConfigsByKeys: (state) => (keys) => {
      if (!Array.isArray(keys)) return []
      return state.configList.filter(item => keys.includes(item.configKey))
    }
  },
  
  actions: {
    // 加载系统配置
    async loadAdminConfig() {
      this.loading = true
      this.error = null
      
      try {
        // 从API获取配置集合（假设res.data是List<SysConfig>）
        const res = await http({
          url: '/system/loadAdminConfig',
          method: 'GET'
        })
		// console.log('配置:'+JSON.stringify(res))
        // 存储配置到state
        this.configList = res || []
        this.isLoaded = true
        
        // 存储到本地缓存
        localStorage.setItem('adminConfig', JSON.stringify(this.configList))
        localStorage.setItem('adminConfigTime', Date.now())
        return this.configList
      } catch (err) {
        this.error = err.message
        console.error('获取配置失败', err)
        throw err
      } finally {
        this.loading = false
      }
    },
    
    // 从缓存加载配置
    loadConfigFromCache() {
      const cachedConfig = localStorage.getItem('adminConfig')
      const cacheTime = localStorage.getItem('adminConfigTime')
      
      // 检查缓存是否有效（假设24小时过期）
      const isExpired = cacheTime && (Date.now() - cacheTime > 24 * 60 * 60 * 1000)
      
      if (cachedConfig && !isExpired) {
        this.configList = cachedConfig
        this.isLoaded = true
        return cachedConfig
      }
      
      return null
    },
    
    // 按条件筛选配置（外部传入筛选函数）
    filterConfigs(filterFn) {
      return this.configList.filter(filterFn)
    }
  }
})